"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "provaglio-val-sabbia": {
    "247bdd21": [{
      "hkey": "f5134040",
      "slug": "provaglio-val-sabbia",
      "name": "Provaglio Val Sabbia",
      "primary": true,
      "skipSearch": false
    }],
    "marzano": [{
      "hkey": "f5134040",
      "slug": "provaglio-val-sabbia",
      "name": "Provaglio Val Sabbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05713d19": [{
      "hkey": "a9bcded4",
      "slug": "arveaco",
      "name": "Arveaco",
      "primary": true,
      "skipSearch": false
    }],
    "provaglio-sopra-arveago": [{
      "hkey": "a9bcded4",
      "slug": "arveaco",
      "name": "Arveaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4135fcbd": [{
      "hkey": "393e0a41",
      "slug": "arvenino",
      "name": "Arvenino",
      "primary": true,
      "skipSearch": false
    }],
    "provaglio-sotto-arvenino-barnico": [{
      "hkey": "393e0a41",
      "slug": "arvenino",
      "name": "Arvenino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;